import { render, staticRenderFns } from "./r-item-shop-product-panel.vue?vue&type=template&id=5ab4b704"
import script from "./r-item-shop-product-panel.vue?vue&type=script&lang=js"
export * from "./r-item-shop-product-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ab4b704')) {
      api.createRecord('5ab4b704', component.options)
    } else {
      api.reload('5ab4b704', component.options)
    }
    module.hot.accept("./r-item-shop-product-panel.vue?vue&type=template&id=5ab4b704", function () {
      api.rerender('5ab4b704', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item-shop/r-item-shop-product-panel.vue"
export default component.exports